import request from './request.js';
import {requestbody} from './request.js'
// 进项发票文件上传
export async function iinv_importIinvExcel (params = {

}) {
	return await request('iinv/file/upload', 'post', params)
}
// 查询进行发票合计结果(分页)
export async function iinv_fetchResultShow(params = {

}) {
	return await requestbody('iinv/list/query', 'post', params)
}
// 导出进项发票合计结果
export async function iinv_outPutIInvResult(params = {

}) {
	return await requestbody('IINV/outPutIInvResult', 'post', params)
}

// 查询票据明细记录
export async function iinv_fetchBillDetails(params = {

}){
	return await requestbody('iinv/details/query', 'post', params)
}
// 删除
export async function iinv_delete(params = {

}){
return await requestbody('iinv/result/delete', 'post', params)
}
// 保存抵扣发票同步任务
export async function syncDeductInvoiceInfo(params = {

}) {
	return await requestbody('/batch/syncInvoiceInfo', 'post', params)
}